import { render, staticRenderFns } from "./AddressFormForRegistration.vue?vue&type=template&id=4eb3cce5&scoped=true&"
import script from "./AddressFormForRegistration.vue?vue&type=script&lang=js&"
export * from "./AddressFormForRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AddressFormForRegistration.vue?vue&type=style&index=0&id=4eb3cce5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3cce5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCard,VCol,VContainer,VForm,VRow,VTextField})
